import React from 'react'
interface DownloadExampleReportButtonProps {
  pdfUrl: string
}
function DownloadExampleReportButton(props: DownloadExampleReportButtonProps) {
  const { pdfUrl } = props
  const ExamplePDF = process.env.REACT_APP_FACE_VIEW_EXAMPLE + pdfUrl
  return (
    <div className="d-flex justify-content-end">
      <a
        href={ExamplePDF}
        target="_blank"
        style={{
          cursor: 'pointer',
          paddingTop: 0,
          marginBottom: '15px',
          fontSize: '9pt',
        }}
        className="blueSentence"
      >
        Sample Report
      </a>
    </div>
  )
}
export default DownloadExampleReportButton
